import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//获取客户地址
export const Hslist = (params) => {
  return axios.post(root + '/set/address/Hslist', qs.stringify(params))
}

//更新地址（含排序值 sort），paracontent 为 JSON 字符串
export const updateAddress = (params) => {
  return axios.post(root + '/set/address/update', qs.stringify(params))
}





// WEBPACK FOOTER //
// ./src/api/set/address.js